import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewPagamentoVenda from "../views/ViewPagamentoVenda";
import ViewContatoVendaPersonalizada from "../views/ViewContatoVendaPersonalizada";





const ContatoVendaPersonalizada: React.FC = () => (
  <>
    <ContatoZap />
    <div>
      <ViewAppBar />

      <ViewContatoVendaPersonalizada/>
      

      <ViewFooter />
    </div>
  </>
);
export default ContatoVendaPersonalizada;

